module.exports = __webpack_public_path__ + "media/images/lb/245-1ab6ba729a87f6d0ad85dfca4fb0768e.svg";